import React from "react";
import { Box, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { DesignTooltip } from "@ui/components/tooltip/DesignTooltip";
const TONES = {
    temperature: { color: "#1D95E2", valueColor: "#00478D" },
    external: { color: "#00B8D9", valueColor: "#003768" },
    co2: { color: "#8E33FF", valueColor: "#27097A" },
    // Teal green of the design (measured against the cyan and blue tiles, which use the same 24% tint).
    humidity: { color: "#00A76F", valueColor: "#123D34" },
    error: { color: "#FF5630", valueColor: "#7A0916" },
    inactive: { color: "#919EAB", valueColor: "#161C24" },
};
/** A sensor reading in the AP details rows, drawn like the temperature tile (TemperatureDisplay). */
export const ReadingTile = ({ value, unit, tone, infoTooltip, width = 91, height = 56, }) => {
    const { color, valueColor } = TONES[tone];
    return (React.createElement(Box, { sx: {
            width,
            height,
            borderRadius: 2,
            backgroundColor: `${color}3D`,
            boxShadow: `0px 8px 16px 0px ${color}3D`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        } },
        React.createElement(Box, { sx: {
                minWidth: 65,
                height: 30,
                px: 0.75,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#FFFFFF",
                borderRadius: 1,
                boxShadow: "0px 4px 8px 0px #919EAB29",
                position: "relative",
            } },
            infoTooltip ? (React.createElement(DesignTooltip, { title: infoTooltip },
                React.createElement(Box, { component: "span", sx: {
                        position: "absolute",
                        right: -5,
                        bottom: -5,
                        width: 14,
                        height: 14,
                        borderRadius: "50%",
                        backgroundColor: "#FFFFFF",
                        color: valueColor,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "default",
                    } },
                    React.createElement(Icon, { icon: "solar:info-circle-linear", width: 12, height: 12 })))) : null,
            React.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "baseline",
                    gap: 0.4,
                    color: valueColor,
                    fontFamily: "Orbitron, sans-serif",
                    userSelect: "none",
                    lineHeight: 1,
                } },
                React.createElement(Typography, { fontWeight: 500, variant: "body2" }, value),
                React.createElement(Box, { component: "span", sx: {
                        // "ppm" sits small and raised, like in the design; "°C" and "%" as on the temperature tile.
                        fontSize: unit.length > 2 ? 8 : 11,
                        fontWeight: 500,
                        alignSelf: unit.length > 2 ? "flex-start" : undefined,
                    } }, unit)))));
};
export default ReadingTile;
